// Where to go after signing in: invite links opened while signed out are remembered for the session
const KEY = 'return_to';
const ALLOWED = /^\/invite\/[a-z0-9]{10}\/[A-Za-z0-9]{6,16}$/;

export function rememberReturnTo(path) {
  if (!ALLOWED.test(path)) return;
  try { sessionStorage.setItem(KEY, path); } catch {}
}

// Returns the remembered path once, or the fallback
export function takeReturnTo(fallback = '/') {
  let path = null;
  try {
    path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
  } catch {}
  return path && ALLOWED.test(path) ? path : fallback;
}
